/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_Other_TitleInputs */

const en_us2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End the other workout?`)
};

const pt_br2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar o outro treino?`)
};

const es_419_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Terminar el otro entrenamiento?`)
};

const pt_pt2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar o outro treino?`)
};

const fr_fr2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'autre séance ?`)
};

const de_de2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das andere Training beenden?`)
};

const it_it2_offline_end_other_title = /** @type {(inputs: Offline_End_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudere l'altro allenamento?`)
};

/**
* | output |
* | --- |
* | "End the other workout?" |
*
* @param {Offline_End_Other_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other_title = /** @type {((inputs?: Offline_End_Other_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_Other_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other_title(inputs)
	if (locale === "es-419") return es_419_offline_end_other_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other_title(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other_title(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other_title(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other_title(inputs)
	return en_us2_offline_end_other_title(inputs)
});
export { offline_end_other_title as "offline.end_other_title" }